class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: 'shopify-section-header',
      background: '.header-background',
      topMenuItem: '.header__menu-item--top',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.list-menu-dropdown > .list-menu',

    };
    this.timeout;

    this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));

     
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    

    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.resetBackground();
    this.animateMenu();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);

    this.header = this.header || document.getElementById(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    let delay = 0;
    if (isTopLevel && !this.isHover()) {
      delay = 150;

      if (this.closest('.header--top-center') || this.closest('.header--top-left')) {
        delay = 200;
      }
    }
    this.timeout = setTimeout(() => {
      if (this.isHover()) {
        this.classList.add(this.classes.active);
      }
    }, delay);

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found) menu.reset();
    });
  }

  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('dropdown-menu', DropdownMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: 'shopify-section-header',
      background: '.header-background',
      dropdown: '.list-menu-dropdown',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.mega-menu__item, .mega-menu__promo'
    };
    this.timeout = [];

    this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));

    this.timers = {};  // Initialize timers object
  }

 handleMouseover() {
    // Clear any existing hover timeouts to avoid multiple timers
    if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
    }

    // Start a new timeout to detect intent
    this.hoverTimeout = setTimeout(() => {
        // Ensure the user is still hovering after the delay
        if (this.matches(':hover')) {
            if (this.classList.contains(this.classes.active)) return;

            this.bindEvent();
            this.removeClasses();
            this.addClasses();
            this.showSublist();
        }
    }, 200); // Adjust delay to your preference
}


  

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    
    this.header = this.header || document.getElementById(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);


        const megaMenuItems = this.querySelectorAll('.mega-menu__item');
    megaMenuItems.forEach(item => {
        item.addEventListener('mouseenter', this.handleMegaMenuItemMouseEnter.bind(this));
        item.addEventListener('mouseleave', this.handleMegaMenuItemMouseLeave.bind(this));
    });


    
  }


handleMegaMenuItemMouseEnter(event) {
    const className = event.target.dataset.className;
    const correspondingChildMenu = this.querySelector(`.list-menu-child.${className}`);
    if (correspondingChildMenu) {
        // Clear the timer specific to this menu item
        if (this.timers[className]) {
            clearTimeout(this.timers[className]);
            delete this.timers[className];
        }
        correspondingChildMenu.classList.add('is-active');
    }
}

handleMegaMenuItemMouseLeave(event) {
    const className = event.target.dataset.className;
    const correspondingChildMenu = this.querySelector(`.list-menu-child.${className}`);
    if (correspondingChildMenu) {
        // Store the timer reference specific to this menu item
        this.timers[className] = setTimeout(() => {
            // Check if the .mega-menu__item element (event.target) is currently being hovered over
            const isHovered = event.target.matches(':hover');
            if (!isHovered) {
                correspondingChildMenu.classList.remove('is-active');
            }
            delete this.timers[className];
        }, 1500);
    }
}





    showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.height = this.header.clientHeight + 700 + 'px';
    background.classList.add(this.classes.active);
  }

  
  
  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 300);
      
      this.timeout.push(timeout);
    });
    
    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);

    if (background.classList.contains(this.classes.active)) {
        setTimeout(() => {
            if (!this.matches(':hover')) {
                background.classList.remove(this.classes.active);
            }
        }, 100); // Adjust delay time as needed
    }
}


  close() {
    this.handleMouseleave();
  }
}
customElements.define('mega-menu', MegaMenu);
